module.exports = __webpack_public_path__ + "img/happy-new-year.57ddca8c.gif";